// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress__hRdNF","progress_item1":"ProgressBar_progress_item1__TzlJz","progress_item2":"ProgressBar_progress_item2__QBglR"};